import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/shared/auth/AuthContext'
import { useAlerts, useMarkAlertRead } from '@/shared/api/queries'
import { relative } from '@/shared/format'
import { Drawer } from '@/shared/ui/Drawer'
import { Row, Rows } from '@/shared/ui/Rows'
import { EmptyState, Skeleton } from '@/shared/ui/primitives'
import { alertTone } from '@/shared/format/tones'

export function AlertDrawer({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { hasModule } = useAuth()
  const alerts = useAlerts(hasModule('risk'))
  const markRead = useMarkAlertRead()
  const nav = useNavigate()
  const unread = alerts.data?.data.filter((a) => !a.read_at) ?? []

  return (
    <Drawer open={open} title="Alertes actives" onClose={onClose}>
      {!hasModule('risk') ? (
        <EmptyState
          title="Module surveillance inactif"
          message="Les alertes ne sont pas souscrites pour ce locataire."
        />
      ) : alerts.isPending ? (
        <Skeleton lines={5} />
      ) : unread.length === 0 ? (
        <EmptyState title="Aucune alerte non lue" message="Tout est sous contrôle." />
      ) : (
        <Rows>
          {unread.map((a) => (
            <Row
              key={a.id}
              tone={alertTone(a)}
              primary={a.title}
              secondary={
                <>
                  {a.detail}
                  <span className="small muted" style={{ display: 'block', marginTop: 3 }}>
                    {relative(a.created_at)}
                  </span>
                </>
              }
              onClick={() => {
                markRead.mutate(a.id)
                onClose()
                nav('/alerts')
              }}
            />
          ))}
        </Rows>
      )}
    </Drawer>
  )
}
